export default __webpack_public_path__ + "static/media/3132 spice rack A top.0836b669.png";